import { Box, TextField } from '@mui/material';
import { StyledDefaultPrimaryButton } from 'styles';
import { Divider } from 'components/material-ui-styles';
import { useTenantSecretMappingForm } from 'TenantModule/components/TenantSecretMappingForm/useTenantSecretMappingForm';
import { TenantSelector } from '../TenantSelector';
import { IntegrationAgentsMultiSelector } from 'IntegrationModule/components/IntegrationAgentsMultiSelector/IntegrationAgentsMultiSelector';
import { FC } from 'react';
import { MaskedInput } from 'components/MaskedInput';

export const TenantSecretMappingForm: FC<ReturnType<typeof useTenantSecretMappingForm>> = ({
  onCreateTenantSecretMappingFormChange,
  onSubmitCreateTenantSecretMappingForm,
  selectedTenant,
  onTenantSelectorClick,
  integrationAgentsSelectorProps,
  createTenantSecretMappingParams,
  isCreatingTenantSecretMapping,
}) => {
  return (
    <form onSubmit={onSubmitCreateTenantSecretMappingForm}>
      <h3>Service Admin Secret Mapping</h3>
      <Box
        sx={{
          gap: 12,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {selectedTenant ? (
          <TenantSelector onClick={onTenantSelectorClick} tenantId={selectedTenant.id} />
        ) : null}
        <IntegrationAgentsMultiSelector {...integrationAgentsSelectorProps} />
        <TextField
          required
          label="DB Host"
          name="dbHost"
          type="text"
          value={createTenantSecretMappingParams.dbHost}
          onChange={onCreateTenantSecretMappingFormChange}
          variant="outlined"
          disabled={isCreatingTenantSecretMapping}
        />
        <TextField
          required
          label="DB Name"
          name="dbName"
          type="text"
          value={createTenantSecretMappingParams.dbName}
          onChange={onCreateTenantSecretMappingFormChange}
          variant="outlined"
          disabled={isCreatingTenantSecretMapping}
        />
        <MaskedInput
          required
          label="DB Password"
          name="dbPassword"
          value={createTenantSecretMappingParams.dbPassword}
          onChange={onCreateTenantSecretMappingFormChange}
          disabled={isCreatingTenantSecretMapping}
          variant="outlined"
        />
        <TextField
          required
          label="DB User"
          name="dbUser"
          type="text"
          value={createTenantSecretMappingParams.dbUser}
          onChange={onCreateTenantSecretMappingFormChange}
          variant="outlined"
          disabled={isCreatingTenantSecretMapping}
        />
        <TextField
          required
          label="DB Host Ro"
          name="roHost"
          type="text"
          value={createTenantSecretMappingParams.roHost}
          onChange={onCreateTenantSecretMappingFormChange}
          variant="outlined"
          disabled={isCreatingTenantSecretMapping}
        />
      </Box>
      <Divider sx={{ my: 3 }} />
      <StyledDefaultPrimaryButton disabled={isCreatingTenantSecretMapping} type="submit">
        Submit
      </StyledDefaultPrimaryButton>
    </form>
  );
};
